import { render, staticRenderFns } from "./enterPhoneEmailPage.vue?vue&type=template&id=706c00e8&scoped=true"
import script from "./enterPhoneEmailPage.vue?vue&type=script&lang=js"
export * from "./enterPhoneEmailPage.vue?vue&type=script&lang=js"
import style0 from "./enterPhoneEmailPage.vue?vue&type=style&index=0&id=706c00e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706c00e8",
  null
  
)

export default component.exports